import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Stepper Root
 */
const Stepper = React.forwardRef(({ className, ...props }, ref) => (
  <nav
    ref={ref}
    className={cn(
      'c-stepper',
      // styles
      'text-neutral-medium mt-8 flex flex-grow flex-col border-t border-solid border-[#E1E7F0] pt-8',
      className
    )}
    {...props}
  />
));
Stepper.displayName = 'Stepper';

const StepperList = React.forwardRef(({ className, ...props }, ref) => (
  <ul
    ref={ref}
    className={cn(
      'c-stepper-list',
      // styles
      'm-0 list-none p-0',
      className
    )}
    {...props}
  />
));
StepperList.displayName = 'StepperList';

/**
 * StepperItem
 */
const StepperItem = React.forwardRef(({ className, active, completed, last, children, ...props }, ref) => (
  <li
    ref={ref}
    className={cn(
      'c-stepper-item',
      // styles

      'relative mb-5 flex min-h-[44px] items-center gap-1 rounded-[5px] pb-2 pl-10 transition-all duration-150',

      // Conector (Linha vertical)
      !last && "after:absolute after:bottom-[-16px] after:left-[12px] after:top-[34px] after:z-20 after:block after:w-[1px] after:bg-[#8B97AF] after:opacity-40 after:content-['']",

      // Indicador Circular
      "before:display-block before:absolute before:left-0 before:top-1 before:z-10 before:h-6 before:w-6 before:rounded-full before:border-2 before:border-solid before:border-secondary before:bg-white before:content-['']",

      // Estado Ativo
      active && 'font-bold before:bg-secondary',

      // Estado Completado
      completed && ['opacity-60'],

      className
    )}
    {...props}
  >
    {completed && (
      <div
        className="absolute left-0 top-1 z-20 size-6 rounded-full bg-secondary bg-center bg-no-repeat"
        style={{
          backgroundSize: '14px',
          backgroundImage:
            'url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>\')'
        }}
      />
    )}
    {children}
  </li>
));
StepperItem.displayName = 'StepperItem';

/**
 * StepperTrigger
 */
const StepperTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'c-stepper-trigger',
      // styles
      'cursor-default border-none bg-transparent p-0 text-left text-sm leading-[1.5] text-neutral-dark no-underline transition-opacity',
      className
    )}
    {...props}
  />
));
StepperTrigger.displayName = 'StepperTrigger';

/**
 * StepperWrapper
 */
const StepperWrapper = React.forwardRef(({ steps, currentStep, className, ...props }, ref) => {
  return (
    <Stepper
      ref={ref}
      className={className}
      {...props}
    >
      <StepperList>
        {steps.map((step, index) => (
          <StepperItem
            key={index}
            active={currentStep === index}
            completed={currentStep > index}
            last={index === steps.length - 1}
          >
            <StepperTrigger>{step.text}</StepperTrigger>
          </StepperItem>
        ))}
      </StepperList>
    </Stepper>
  );
});
StepperWrapper.displayName = 'StepperWrapper';

export { StepperWrapper, Stepper };
